module.exports = __webpack_public_path__ + "img/37.8f152100.jpg";